import { atom } from 'jotai';
import type { StopPoint } from './types';

export const isStopPointsLoadedAtom = atom(false);

export const stopPointsAtom = atom<StopPoint[]>([]);

export const hasStopPointsSelector = atom((get) => {
  const stopPoints = get(stopPointsAtom);
  return stopPoints.length > 0;
});

/**
 * 停車地点の緯度経度を返す
 */
export const stopPointsLatLngSelector = atom((get) => {
  const stopPoints = get(stopPointsAtom);
  return stopPoints.map((stopPoint) => stopPoint.location);
});
